import { t } from 'i18next';
import { CategoryConfig, EfficiencyCategory } from './types';

export const MAX_WIDTH_BAR = 408;

export const CATEGORY_CONFIG: Record<EfficiencyCategory, CategoryConfig> = {
  A: { label: 'A', color: '#039340', width: 56 },
  B: { label: 'B', color: '#05A935', width: 132 },
  C: { label: 'C', color: '#99D014', width: 190 },
  D: { label: 'D', color: '#FDF900', width: 238 },
  E: { label: 'E', color: '#F1AE02', width: 276 },
  F: { label: 'F', color: '#E4650A', width: 328 },
  G: { label: 'G', color: '#DE2917', width: MAX_WIDTH_BAR },
} as const;

export const CATEGORY_ORDER: EfficiencyCategory[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

export const mockCategoryValues: Record<EfficiencyCategory, {
 PERCENTAGE: number,
 UNITS: number
}> = {
  A: { PERCENTAGE: 16.57, UNITS: 145 },
  B: { PERCENTAGE: 31.2, UNITS: 273 },
  C: { PERCENTAGE: 16.57, UNITS: 221 },
  D: { PERCENTAGE: 26.86, UNITS: 235 },
  E: { PERCENTAGE: 0, UNITS: 0 },
  F: { PERCENTAGE: 0, UNITS: 0 },
  G: { PERCENTAGE: 0.11, UNITS: 1 },
};

export const rankingOptions: { name: string, value: string}[] = [
  { name: t('comparativo'), value: 'comparative' },
  { name: t('absoluto'), value: 'absolute' },
];
